import {call, put, takeLatest} from 'redux-saga/effects';
import {
    TASK_SUM_REQUEST,
    TASK_SUM_SUCCESS,
    TASK_SUM_FAIL,
    ACCOUNTANT_TASK_REQUEST,
    ACCOUNTANT_TASK_SUCCESS,
    ACCOUNTANT_TASK_FAIL,
    COMPANY_TASK_SUCCESS,
    COMPANY_TASK_FAIL,
    COMPANY_TASK_REQUEST,
    MANAGER_TASK_SUCCESS,
    MANAGER_TASK_FAIL, MANAGER_TASK_REQUEST, GET_TASK_SUCCESS, GET_TASK_FAIL, GET_TASK_REQUEST,
} from '../actions/task.js';
import Api from '../../Api.js';
import {NOTIFY_FAIL, NOTIFY_REQUEST, NOTIFY_SUCCESS} from "../actions/notification.js";




function* handleTaskSumRequest(action) {

    try {
        // let profession = localStorage.getItem('profession')
        // let id = localStorage.getItem('id')

        const {id,prof} = action.payload;
        const {data} = yield call(Api.todayTaskSum, id, prof);
        yield put({
            type: TASK_SUM_SUCCESS,
            payload: {data},
        });
    } catch (e) {
        yield put({
            type: TASK_SUM_FAIL,
            payload: {error: e.response},
        });
    }
}

function* handleTaskRequest(action) {
    try {
        const {query} = action.payload;
        const {data} = yield call(Api.taskData,query);
        yield put({
            type: GET_TASK_SUCCESS,
            payload: {data},
        });
    } catch (e) {
        console.log(e)

        yield put({
            type: GET_TASK_FAIL,
            payload: {error: e.response},
        });
    }
}

function* handleTaskAccRequest(action) {

    try {
        const {data} = yield call(Api.getAccountTitle,);
        yield put({
            type: ACCOUNTANT_TASK_SUCCESS,
            payload: {data},
        });
    } catch (e) {
        yield put({
            type: ACCOUNTANT_TASK_FAIL,
            payload: {error: e.response},
        });
    }
}
function* handleTaskCompaniesRequest(action) {

    try {
        const {data} = yield call(Api.getCompaniesTitle,);
        yield put({
            type: COMPANY_TASK_SUCCESS,
            payload: {data},
        });
    } catch (e) {
        yield put({
            type: COMPANY_TASK_FAIL,
            payload: {error: e.response},
        });
    }
}

function* handleTaskManagerRequest(action) {

    try {
        const {data} = yield call(Api.getManager,);
        yield put({
            type: MANAGER_TASK_SUCCESS,
            payload: {data},
        });
    } catch (e) {
        yield put({
            type: MANAGER_TASK_FAIL,
            payload: {error: e.response},
        });
    }
}

function* handleNotifyRequest(action) {

    try {
        const {data} = yield call(Api.getNotify,);
        yield put({
            type: NOTIFY_SUCCESS,
            payload: {data},
        });
    } catch (e) {
        yield put({
            type: NOTIFY_FAIL,
            payload: {error: e.response},
        });
    }
}


export default function* watcher() {
    yield takeLatest(TASK_SUM_REQUEST, handleTaskSumRequest);
    yield takeLatest(GET_TASK_REQUEST, handleTaskRequest);
    yield takeLatest(ACCOUNTANT_TASK_REQUEST, handleTaskAccRequest);
    yield takeLatest(COMPANY_TASK_REQUEST, handleTaskCompaniesRequest);
    yield takeLatest(MANAGER_TASK_REQUEST, handleTaskManagerRequest);
    yield takeLatest(NOTIFY_REQUEST, handleNotifyRequest);

}
